import script from "./pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./pagination.vue?vue&type=script&setup=true&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=ea095338&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea095338"]])

export default __exports__